<template>
  <v-container class="fill-height" fluid></v-container>
</template>


<script>
export default {
  props: {
    source: String
  }
};
</script>


// WEBPACK FOOTER //
// src/components/app/Setting.vue